import { ComponentProps } from 'react';

function RocketIllustration(props: ComponentProps<'svg'>) {
  return (
    <svg
      viewBox='0 0 239 195'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_793_8224)'>
        <path
          d='M204.545 178.374V192.923C204.544 193.474 204.326 194.002 203.938 194.391C203.551 194.78 203.025 194.999 202.477 195H38.2531C37.7051 194.999 37.1799 194.78 36.7924 194.39C36.4049 194.001 36.1867 193.474 36.1855 192.923V174.494C36.3805 174.286 36.5754 174.081 36.7763 173.876C47.685 162.518 60.8187 153.554 75.349 147.55C89.8793 141.546 105.491 138.631 121.199 138.99C136.907 139.349 152.37 142.974 166.613 149.636C180.857 156.298 193.571 165.853 203.954 177.698C204.155 177.92 204.35 178.149 204.545 178.374Z'
          fill='#1B229F'
        />
        <path
          d='M150.345 18.77C150.179 18.6691 150.014 18.5712 149.849 18.4763H132.587C132.463 18.6721 132.345 18.8709 132.23 19.0696H150.841C150.676 18.9688 150.51 18.8708 150.345 18.77ZM36.1855 77.3551V81.7756C36.2594 81.7815 36.3362 81.7815 36.41 81.7845L36.2623 90.2814L36.1855 90.2398V91.0765L36.2476 91.1091L36.1855 94.6722V106.955H36.7763V75.3525C36.6109 75.9933 36.414 76.6609 36.1855 77.3551ZM150.345 18.77C150.179 18.6691 150.014 18.5712 149.849 18.4763H132.587C132.463 18.6721 132.345 18.8709 132.23 19.0696H150.841C150.676 18.9688 150.51 18.8708 150.345 18.77ZM202.477 18.4763H38.2531C37.7049 18.4769 37.1794 18.6959 36.7918 19.0852C36.4042 19.4745 36.1861 20.0024 36.1855 20.553V192.923C36.1867 193.474 36.4049 194.001 36.7924 194.39C37.1799 194.78 37.7051 194.999 38.2531 195H202.477C203.025 194.999 203.551 194.78 203.938 194.391C204.326 194.002 204.544 193.474 204.545 192.923V20.553C204.544 20.0024 204.326 19.4745 203.938 19.0852C203.551 18.6959 203.025 18.4769 202.477 18.4763ZM203.954 192.923C203.954 193.317 203.798 193.694 203.521 193.972C203.244 194.25 202.869 194.407 202.477 194.407H38.2531C37.8615 194.407 37.4859 194.25 37.209 193.972C36.9321 193.694 36.7764 193.317 36.7763 192.923V20.553C36.7769 20.1598 36.9327 19.7829 37.2095 19.5048C37.4864 19.2268 37.8616 19.0703 38.2531 19.0696H202.477C202.868 19.0703 203.244 19.2268 203.521 19.5048C203.797 19.7829 203.953 20.1598 203.954 20.553V192.923Z'
          fill='#FF5227'
        />
        <path
          d='M104.276 171.686L98.4182 171.849C97.5284 171.895 96.6481 171.647 95.9118 171.143C95.2757 170.668 94.9839 170.025 95.1118 169.38L96.2645 163.561C96.4817 162.463 97.8209 161.634 99.4485 161.588L102.684 161.499C104.311 161.454 105.694 162.208 105.971 163.292L107.442 169.038C107.605 169.675 107.349 170.333 106.74 170.843C106.032 171.386 105.167 171.683 104.276 171.686Z'
          fill='#FF5227'
        />
        <path
          d='M139.906 171.52L134.048 171.682C133.159 171.728 132.278 171.48 131.542 170.977C130.906 170.501 130.614 169.859 130.742 169.214L131.895 163.395C132.112 162.297 133.451 161.467 135.079 161.422L138.314 161.332C139.941 161.287 141.324 162.042 141.601 163.126L143.072 168.872C143.235 169.509 142.979 170.166 142.37 170.676C141.662 171.22 140.797 171.516 139.906 171.52Z'
          fill='#FF5227'
        />
        <path
          d='M83.9354 122.122C83.6678 122.006 83.4476 121.802 83.3112 121.543C83.1748 121.284 83.1304 120.987 83.1853 120.699C83.2402 120.412 83.3912 120.152 83.6133 119.962C83.8354 119.773 84.1152 119.665 84.4065 119.657L151.002 117.81C151.17 117.805 151.337 117.834 151.494 117.894C151.651 117.954 151.795 118.045 151.917 118.161C152.039 118.277 152.137 118.416 152.205 118.57C152.274 118.724 152.312 118.89 152.316 119.058C152.325 119.399 152.199 119.729 151.966 119.976C151.733 120.224 151.412 120.368 151.073 120.378L84.4772 122.225C84.2912 122.231 84.1063 122.195 83.9354 122.122Z'
          fill='#FF5227'
        />
        <path
          d='M108.513 99.9773L89.4766 100.505L91.2513 165.062L110.287 164.534L108.513 99.9773Z'
          fill='#E6E6E6'
        />
        <path
          d='M108.996 98.8174L105.336 108.83L105.34 154.447L109.799 155.731L108.996 98.8174Z'
          fill='#FFFF00'
        />
        <path
          d='M98.8953 83.1061C95.3339 83.2077 92.6167 89.3984 92.6821 91.8142L92.8023 96.1877L105.698 95.8301L105.578 91.4565C105.51 89.0408 102.457 83.0102 98.8953 83.1061Z'
          fill='#FF5227'
        />
        <path
          d='M89.7236 127.24C89.0582 127.257 88.413 127.009 87.9295 126.55C87.446 126.09 87.1638 125.457 87.1446 124.789L86.949 117.671C86.9306 117.002 87.1774 116.354 87.635 115.868C88.0927 115.382 88.7237 115.099 89.3893 115.081C90.0549 115.062 90.7006 115.31 91.1842 115.77C91.6679 116.229 91.9499 116.863 91.9683 117.532L92.164 124.649C92.1816 125.318 91.9345 125.966 91.477 126.451C91.0195 126.937 90.3889 127.22 89.7236 127.24Z'
          fill='#FF5227'
        />
        <path
          d='M94.5542 100.658L94.4641 95.9544L95.6922 95.9239L95.7823 100.613L96.8956 168.951L95.6671 168.985'
          fill='#FF5227'
        />
        <path
          d='M110.696 111.658L88.6202 112.27C86.5118 109.688 86.3203 98.6848 90.7206 96.5907L92.4462 93.6476L105.75 92.9952L107.305 96.0941C109.494 97.9649 110.623 108.899 110.696 111.658Z'
          fill='#E6E6E6'
        />
        <path
          d='M102.387 106.381L96.8043 106.536C95.7271 106.566 94.8112 105.162 94.763 103.407C94.7147 101.652 95.5521 100.2 96.6293 100.17L102.212 100.015C103.289 99.985 104.205 101.389 104.253 103.144C104.301 104.899 103.464 106.351 102.387 106.381Z'
          fill='#1B229F'
        />
        <path
          d='M91.5763 138.124L80.0691 146.289L78.0588 164.698L91.4827 160.192L91.5763 138.124Z'
          fill='#E6E6E6'
        />
        <path
          d='M145.26 99.1866L126.223 99.7146L127.998 164.271L147.034 163.743L145.26 99.1866Z'
          fill='#E6E6E6'
        />
        <path
          d='M126.679 99.0331L130.596 108.947L131.771 154.549L127.347 155.949L126.679 99.0331Z'
          fill='#FFFF00'
        />
        <path
          d='M154.779 81.2635C156.157 81.2635 157.274 79.7589 157.274 77.9029C157.274 76.0469 156.157 74.5423 154.779 74.5423C153.401 74.5423 152.284 76.0469 152.284 77.9029C152.284 79.7589 153.401 81.2635 154.779 81.2635Z'
          fill='#E6E6E6'
        />
        <path
          d='M167.822 130.601C169.2 130.601 170.318 129.097 170.318 127.241C170.318 125.385 169.2 123.88 167.822 123.88C166.444 123.88 165.327 125.385 165.327 127.241C165.327 129.097 166.444 130.601 167.822 130.601Z'
          fill='#E6E6E6'
        />
        <path
          d='M70.7319 121.17C72.1099 121.17 73.227 119.665 73.227 117.809C73.227 115.953 72.1099 114.449 70.7319 114.449C69.3539 114.449 68.2368 115.953 68.2368 117.809C68.2368 119.665 69.3539 121.17 70.7319 121.17Z'
          fill='#E6E6E6'
        />
        <path
          d='M135.271 82.3258C131.709 82.4274 128.992 88.6181 129.057 91.0339L129.178 95.4074L142.073 95.0498L141.953 90.6762C141.885 88.2605 138.832 82.2299 135.271 82.3258Z'
          fill='#FF5227'
        />
        <path
          d='M138.958 102.131L138.868 97.4269L140.096 97.396L140.186 102.085L141.299 170.424L140.071 170.458'
          fill='#FF5227'
        />
        <path
          d='M147.071 110.878L124.995 111.49C124.611 109.153 125.108 98.2485 127.096 95.8104L128.821 92.8672L142.125 92.2149L143.68 95.3137C147.608 95.6353 148.982 106.351 147.071 110.878Z'
          fill='#E6E6E6'
        />
        <path
          d='M138.789 106.583L133.206 106.738C132.129 106.768 131.207 105.144 131.152 103.118C131.096 101.092 131.927 99.4193 133.004 99.3894L138.587 99.2346C139.664 99.2047 140.586 100.829 140.642 102.855C140.697 104.88 139.866 106.553 138.789 106.583Z'
          fill='#1B229F'
        />
        <path
          d='M146.2 133.405L157.324 142.088L158.496 160.57L145.291 155.455L146.2 133.405Z'
          fill='#E6E6E6'
        />
        <path
          d='M143.093 47.8011C131.157 47.8011 117.439 34.4962 105.302 40.8177C68.5535 59.9575 73.6121 27.93 63.0547 16.0187L63.4013 15.3204C71.3938 45.943 78.6254 94.739 105.461 40.0054C112.183 26.2948 134.246 47.4877 147.233 46.8625L147.255 47.7018C145.884 47.7683 144.497 47.8013 143.093 47.8011Z'
          fill='#F2F2F2'
        />
        <path
          d='M171.743 49.6838C162.228 56.9227 143.295 54.6358 137.419 67.0356C119.63 104.579 104.411 75.98 88.8348 72.8872L88.6914 72.1203C104.284 73.4193 121.009 71.4038 137.058 66.2914C151.562 61.6717 164.502 54.7994 174.479 46.4252L175.001 47.0807C173.948 47.9654 172.862 48.8331 171.743 49.6838Z'
          fill='#F2F2F2'
        />
        <path
          d='M68.2368 48.0355C69.6148 48.0355 70.7318 46.5309 70.7318 44.6749C70.7318 42.8189 69.6148 41.3143 68.2368 41.3143C66.8588 41.3143 65.7417 42.8189 65.7417 44.6749C65.7417 46.5309 66.8588 48.0355 68.2368 48.0355Z'
          fill='#E6E6E6'
        />
        <path
          d='M145.623 20.7411C147.001 20.7411 148.118 19.2365 148.118 17.3805C148.118 15.5245 147.001 14.0199 145.623 14.0199C144.245 14.0199 143.128 15.5245 143.128 17.3805C143.128 19.2365 144.245 20.7411 145.623 20.7411Z'
          fill='#E6E6E6'
        />
        <path
          d='M65.7417 91.1796C67.1196 91.1796 68.2367 89.675 68.2367 87.8189C68.2367 85.9629 67.1196 84.4583 65.7417 84.4583C64.3637 84.4583 63.2466 85.9629 63.2466 87.8189C63.2466 89.675 64.3637 91.1796 65.7417 91.1796Z'
          fill='#E6E6E6'
        />
        <path
          d='M91.0801 61.5991C89.9394 62.3625 88.7719 60.5455 89.9345 59.816C91.0752 59.0527 92.2426 60.8697 91.0801 61.5991Z'
          fill='#E6E6E6'
        />
        <path
          d='M133.317 1.96674C132.177 2.73015 131.009 0.913158 132.172 0.183647C133.312 -0.579725 134.48 1.23726 133.317 1.96674Z'
          fill='#E6E6E6'
        />
        <path
          d='M158.211 37.3225L157.485 37.1626L157.644 36.4333L157.16 36.3268L157.001 37.056L156.275 36.8964L156.169 37.3824L156.895 37.5423L156.736 38.2712L157.22 38.3778L157.379 37.6485L158.104 37.8084L158.211 37.3225Z'
          fill='#E6E6E6'
        />
        <path
          d='M91.6897 12.8876C93.4355 12.8876 94.8508 11.466 94.8508 9.71241C94.8508 7.95883 93.4355 6.53726 91.6897 6.53726C89.9438 6.53726 88.5286 7.95883 88.5286 9.71241C88.5286 11.466 89.9438 12.8876 91.6897 12.8876Z'
          fill='#FFFF00'
        />
        <path
          d='M114.811 5.69339C111.25 5.79499 108.533 11.9857 108.598 14.4015L108.718 18.775L121.614 18.4173L121.494 14.0438C121.426 11.6281 118.373 5.59743 114.811 5.69339Z'
          fill='#FF5227'
        />
        <path
          d='M122.49 171.305L116.632 171.467C115.742 171.513 114.862 171.265 114.126 170.762C113.49 170.286 113.198 169.644 113.326 168.999L114.478 163.18C114.696 162.082 116.035 161.252 117.662 161.207L120.897 161.117C122.525 161.072 123.908 161.827 124.185 162.911L125.656 168.657C125.819 169.294 125.563 169.951 124.954 170.461C124.246 171.005 123.381 171.301 122.49 171.305Z'
          fill='#FF5227'
        />
        <path
          d='M125.102 33.5354L106.066 34.0634L109.653 164.557L128.69 164.029L125.102 33.5354Z'
          fill='#E6E6E6'
        />
        <path
          d='M117.485 96.7021L117.395 91.9982L118.623 91.9677L118.713 96.6564L119.826 164.995L118.598 165.029'
          fill='#FF5227'
        />
        <path
          d='M128.85 45.4783L103.057 46.1937C102.607 43.4633 103.189 30.722 105.511 27.8732L106.147 24.4726L123.957 23.9787L124.888 27.2929C127.446 29.4788 128.765 42.2547 128.85 45.4783Z'
          fill='#E6E6E6'
        />
        <path
          d='M124.52 24.3799L106.141 24.8897C105.463 24.9085 104.903 24.5507 104.89 24.0906C104.888 24.0243 104.898 23.9582 104.919 23.8952L107.773 15.0616C107.896 14.6833 108.382 14.4055 108.95 14.3898L121.138 14.0517C121.706 14.036 122.207 14.2864 122.35 14.6573L125.686 23.3193C125.856 23.7623 125.462 24.2233 124.806 24.349C124.711 24.367 124.616 24.3773 124.52 24.3799Z'
          fill='#E6E6E6'
        />
        <path
          d='M107.954 96.102C107.788 96.0307 107.632 95.9395 107.487 95.8306C107.281 95.6849 107.11 95.4936 106.988 95.2714C106.866 95.0491 106.797 94.8019 106.785 94.5485L106.117 70.2572C106.089 69.2516 107.069 68.4057 108.302 68.3715L124.755 67.9151C125.987 67.8806 127.012 68.6713 127.04 69.6768L127.708 93.9682C127.71 94.2219 127.654 94.4726 127.544 94.7013C127.435 94.9299 127.275 95.1303 127.077 95.2873C126.637 95.6468 126.089 95.8465 125.523 95.8539L109.07 96.3101C108.687 96.3229 108.307 96.252 107.954 96.102Z'
          fill='#FF5227'
        />
        <path
          d='M118.485 22.8166L112.902 22.9714C111.825 23.0013 110.914 21.7788 110.872 20.2467C110.83 18.7145 111.672 17.4434 112.75 17.4135L118.332 17.2587C119.409 17.2288 120.32 18.4513 120.362 19.9834C120.404 21.5156 119.562 22.7867 118.485 22.8166Z'
          fill='#1B229F'
        />
        <path
          d='M145.731 125.663C145.065 125.681 144.42 125.433 143.937 124.973C143.453 124.513 143.171 123.88 143.152 123.212L142.956 116.094C142.938 115.426 143.185 114.778 143.643 114.292C144.101 113.807 144.731 113.524 145.397 113.505C146.062 113.487 146.707 113.735 147.191 114.194C147.675 114.653 147.957 115.287 147.976 115.955L148.171 123.073C148.189 123.741 147.942 124.389 147.484 124.875C147.027 125.36 146.396 125.644 145.731 125.663Z'
          fill='#FF5227'
        />
        <path
          d='M54.0376 145.846C51.0112 145.846 49.0438 145.09 48.173 143.589C46.4557 140.628 49.3318 135.432 56.7211 128.146L57.3419 128.781C50.4779 135.549 47.4935 140.649 48.9385 143.141C49.8528 144.717 52.574 145.282 56.8095 144.774C61.0142 144.27 66.5864 142.767 73.3713 140.307C87.3395 135.244 104.864 126.703 122.717 116.257C140.569 105.812 156.61 94.7136 167.886 85.0066C170.052 83.1418 172.018 81.3478 173.728 79.6749C175.974 77.5324 178.046 75.2132 179.924 72.7393C182.453 69.2899 183.307 66.6334 182.392 65.057C180.865 62.4241 174.451 62.6717 164.329 65.7551L164.072 64.9033C174.931 61.5956 181.353 61.4964 183.158 64.6091C184.28 66.543 183.432 69.456 180.637 73.2672C178.731 75.7802 176.627 78.1362 174.346 80.3126C172.622 81.9987 170.643 83.8052 168.463 85.6824C157.147 95.4234 141.06 106.555 123.163 117.026C105.265 127.498 87.6891 136.063 73.6721 141.145C66.824 143.627 61.186 145.145 56.9145 145.657C55.9601 145.777 54.9994 145.84 54.0376 145.846Z'
          fill='#FF5227'
        />
        <path
          d='M125.019 41.3143L136.143 49.9975L137.315 68.4796L124.11 63.3637L125.019 41.3143Z'
          fill='#E6E6E6'
        />
        <path
          d='M108.214 41.3143L97.0899 49.9975L95.9185 68.4796L109.123 63.3637L108.214 41.3143Z'
          fill='#E6E6E6'
        />
        <path
          d='M114.491 27.8359L114.401 23.132L115.629 23.1015L115.72 27.7905L116.833 36.7935L115.604 36.8276'
          fill='#FF5227'
        />
        <path
          d='M58.451 65.148C59.6006 64.701 60.2816 63.6875 59.972 62.8843C59.6624 62.081 58.4796 61.7922 57.33 62.2392C56.1804 62.6862 55.4995 63.6997 55.809 64.5029C56.1186 65.3062 57.3015 65.595 58.451 65.148Z'
          fill='#E6E6E6'
        />
        <path
          d='M72.9252 63.283C74.0747 62.8361 74.7557 61.8226 74.4461 61.0193C74.1366 60.2161 72.9537 59.9272 71.8041 60.3742C70.6546 60.8212 69.9736 61.8347 70.2832 62.6379C70.5927 63.4412 71.7756 63.73 72.9252 63.283Z'
          fill='#E6E6E6'
        />
        <path
          d='M57.1957 77.5516C58.3452 77.1046 59.0262 76.0911 58.7166 75.2879C58.4071 74.4846 57.2242 74.1958 56.0746 74.6428C54.9251 75.0897 54.2441 76.1032 54.5537 76.9065C54.8632 77.7097 56.0461 77.9986 57.1957 77.5516Z'
          fill='#E6E6E6'
        />
        <path
          d='M53.0085 83.0229C53.5359 82.8975 53.818 82.1785 53.6385 81.4171C53.4591 80.6556 52.8861 80.1399 52.3587 80.2653C51.8313 80.3907 51.5493 81.1096 51.7287 81.8711C51.9082 82.6326 52.4811 83.1483 53.0085 83.0229Z'
          fill='#E6E6E6'
        />
        <path
          d='M52.9224 92.2859C53.4497 92.1606 53.7318 91.4416 53.5524 90.6801C53.3729 89.9187 52.7999 89.403 52.2725 89.5284C51.7452 89.6538 51.4631 90.3727 51.6425 91.1342C51.822 91.8957 52.395 92.4113 52.9224 92.2859Z'
          fill='#E6E6E6'
        />
        <path
          d='M65.6257 73.1C66.1531 72.9746 66.4352 72.2556 66.2557 71.4942C66.0763 70.7327 65.5033 70.217 64.9759 70.3424C64.4485 70.4678 64.1665 71.1867 64.3459 71.9482C64.5253 72.7097 65.0983 73.2254 65.6257 73.1Z'
          fill='#E6E6E6'
        />
        <path
          d='M58.0027 71.2406C58.5301 71.1152 58.8121 70.3963 58.6327 69.6348C58.4532 68.8733 57.8802 68.3576 57.3529 68.483C56.8255 68.6084 56.5434 69.3273 56.7229 70.0888C56.9023 70.8503 57.4753 71.366 58.0027 71.2406Z'
          fill='#E6E6E6'
        />
        <path
          d='M66.0827 62.7108C66.6101 62.5855 66.8922 61.8665 66.7128 61.105C66.5333 60.3436 65.9603 59.8279 65.4329 59.9533C64.9056 60.0787 64.6235 60.7976 64.8029 61.5591C64.9824 62.3206 65.5554 62.8362 66.0827 62.7108Z'
          fill='#E6E6E6'
        />
        <path
          d='M185.006 106.995C186.197 106.677 186.984 105.744 186.763 104.911C186.543 104.079 185.398 103.662 184.207 103.981C183.016 104.3 182.229 105.233 182.45 106.065C182.67 106.897 183.815 107.314 185.006 106.995Z'
          fill='#E6E6E6'
        />
        <path
          d='M170.416 107.267C171.607 106.948 172.394 106.015 172.173 105.183C171.952 104.35 170.808 103.934 169.617 104.253C168.426 104.571 167.639 105.504 167.86 106.337C168.08 107.169 169.225 107.585 170.416 107.267Z'
          fill='#E6E6E6'
        />
        <path
          d='M187.598 94.8025C188.789 94.4839 189.576 93.5508 189.355 92.7185C189.135 91.8862 187.99 91.4698 186.799 91.7884C185.608 92.1071 184.821 93.0401 185.042 93.8724C185.262 94.7047 186.407 95.1212 187.598 94.8025Z'
          fill='#E6E6E6'
        />
        <path
          d='M191.901 89.6197C192.439 89.5527 192.797 88.8688 192.701 88.0923C192.605 87.3157 192.092 86.7405 191.554 86.8074C191.016 86.8744 190.658 87.5582 190.754 88.3348C190.849 89.1114 191.363 89.6866 191.901 89.6197Z'
          fill='#E6E6E6'
        />
        <path
          d='M192.99 80.421C193.528 80.354 193.887 79.6702 193.791 78.8936C193.695 78.1171 193.181 77.5418 192.643 77.6088C192.105 77.6758 191.747 78.3596 191.843 79.1362C191.939 79.9128 192.453 80.488 192.99 80.421Z'
          fill='#E6E6E6'
        />
        <path
          d='M178.284 98.1042C178.821 98.0372 179.18 97.3534 179.084 96.5768C178.988 95.8002 178.474 95.225 177.936 95.292C177.399 95.3589 177.04 96.0428 177.136 96.8193C177.232 97.5959 177.746 98.1712 178.284 98.1042Z'
          fill='#E6E6E6'
        />
        <path
          d='M185.66 100.786C186.198 100.719 186.556 100.035 186.46 99.2585C186.364 98.482 185.851 97.9067 185.313 97.9737C184.775 98.0407 184.417 98.7245 184.512 99.5011C184.608 100.278 185.122 100.853 185.66 100.786Z'
          fill='#E6E6E6'
        />
        <path
          d='M176.704 108.382C177.241 108.315 177.6 107.631 177.504 106.854C177.408 106.078 176.894 105.502 176.356 105.569C175.819 105.636 175.46 106.32 175.556 107.097C175.652 107.873 176.166 108.449 176.704 108.382Z'
          fill='#E6E6E6'
        />
        <path
          d='M212.266 155.233C208.452 155.233 204.272 155.088 199.725 154.799C176.21 153.299 145.751 148.084 113.958 140.116C82.1653 132.147 52.8376 122.376 31.3777 112.603C20.9239 107.843 12.9007 103.336 7.53116 99.2091C1.84621 94.8399 -0.640461 91.0315 0.139921 87.89C1.66047 81.7698 15.1242 80.4309 26.1511 80.3854L26.1548 81.2754C11.012 81.3378 2.07842 83.7636 0.999787 88.1055C-0.374215 93.6357 10.8315 102.269 31.7436 111.793C53.1564 121.544 82.4301 131.296 114.173 139.252C145.915 147.208 176.318 152.414 199.782 153.911C222.696 155.373 236.627 153.039 238 147.509C239.141 142.917 231.621 136.153 216.826 128.463L217.233 127.672C227.983 133.261 240.462 141.275 238.86 147.724C238.08 150.866 234.103 153.054 227.041 154.228C223.015 154.898 218.071 155.233 212.266 155.233Z'
          fill='#1B229F'
        />
      </g>
      <defs>
        <clipPath id='clip0_793_8224'>
          <rect width='239' height='195' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export { RocketIllustration };
